import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="pj6c83lngiqh">
        <span className="block text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-19" data-mp="avd0itzoq0d6">
          Dziś w pakiecie
        </span>
        <h2 className="mt-5 text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-20" data-mp="fsliatgx82dw">
          5 Ekskluzywnych Dodatków
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-21" data-mp="5wrwskl84yjz">
          O wartości{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-22" data-mp="3o2n25tfqfwh0">250 zł</span> —
          dziś w cenie zestawu,{' '}
          <span className="font-bold text-brand" data-id="element-23" data-mp="3t1hm4ypfrr2p">bez dodatkowych kosztów</span>.
        </p>

        <ol className="mt-9 space-y-4" data-id="element-24" data-mp="1mbjr531xkfvx">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-25" data-mp="1r9l5xbsbpt1l" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-26" data-mp="3dfld14naiu0w">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-28 w-24 shrink-0 object-contain sm:h-32 sm:w-28" data-id="element-27" data-mp="3n5esigqjztaf" />
              <div data-id="element-28" data-mp="2zhoi0cohivoc">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-29" data-mp="2ughbegy2w2j9">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-ink/55" data-id="element-30" data-mp="38hbh2rtqrpe8">
                  {bonus.text}
                </p>
                <p className="mt-2 text-[11px] font-bold" data-id="element-31" data-mp="33fujb56k0j1v">
                  <span className="text-amber-700 line-through" data-id="element-32" data-mp="np8e6pwrzrnh">
                    wartość {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-33" data-mp="iqf1gzpbc4od">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}